import React from 'react';
import MainNavigation from '../../components/ui/MainNavigation';
import HeroSection from './components/HeroSection';
import CostCalculatorSection from './components/CostCalculatorSection';
import PaybackPeriodSection from './components/PaybackPeriodSection';
import ComparisonTableSection from './components/ComparisonTableSection';
import SavingsVisualizationSection from './components/SavingsVisualizationSection';
import FooterSection from '../homepage/components/FooterSection';

const CostsAndPaybackPeriodGuide = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <MainNavigation />

      {/* Main Content with proper spacing for fixed navigation */}
      <main className="pt-16 lg:pt-0 lg:ml-[72px] transition-all duration-300">
        {/* Hero Section */}
        <HeroSection />

        {/* Cost Calculator */}
        <CostCalculatorSection />

        {/* Payback Period */}
        <PaybackPeriodSection />

        {/* Comparison Tables */}
        <ComparisonTableSection />

        {/* Savings Visualization */}
        <SavingsVisualizationSection />
      </main>

      {/* Footer */}
      <FooterSection />
    </div>
  );
};

export default CostsAndPaybackPeriodGuide;